import dayjs from 'dayjs';
import Cleave from 'cleave.js';
import BaseComponent from '../abstracts/BaseComponent';

export default class BirthDateComponent extends BaseComponent {
  constructor(element) {
    super(element);

    if (this.$el.value) {
      const birthDate = dayjs(Number(this.$el.value)).format('DD/MM/YYYY');
      this.$el.value = birthDate;
    }

    const date = new Cleave(this.$el, {
      date: true,
      delimiter: '/',
      datePattern: ['d', 'm', 'Y']
    });
  }
}
